import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExternalComponent } from './external.component';

const routes: Routes = [
  {
    path: '',
    component: ExternalComponent,
    children: [
      {
        path: 'confirmar-asignacion',
        loadChildren: () => import('../requerimiento-externo/confirmar-asignacion/confirmar-asignacion.module').then(m => m.ConfirmarAsignacionModule)
      }
    ]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExternalRoutingModule { }
